const DEFAULT_AUTH_ENCRYPTION_KEY = 'local-dev-thirdwave-key';

export const AUTH_ENCRYPTION_KEY =
  process.env.REACT_APP_AUTH_ENCRYPTION_KEY || DEFAULT_AUTH_ENCRYPTION_KEY;
